import type { MenuProps } from 'antd';

import { cn } from "#src/utils/cn";
import { Menu } from 'antd';
import React from 'react';

import './CustomMenu.scss';

interface CustomMenuProps extends MenuProps {
	/** Optional extra class for the container div */
	containerClassName?: string
}

/**
 * A High-Order Quality Menu component that wraps Ant Design's Menu.
 * It centralizes styling and behavior for consistent UI across the app.
 */
export const CustomMenu: React.FC<CustomMenuProps> = ({
																												className,
																												mode = "inline",
																												theme,
																												containerClassName,
																												...props
																											}) => {
	return (
		<div className={cn("", containerClassName)}>
			<Menu
				mode={mode}
				theme={theme}
				inlineIndent={16}
				/* Merging custom styles with antd's default classes */
				className={cn(
					"",
					"",
					className,
				)}
				{...props}
			/>
		</div>
	);
};
